export default __webpack_public_path__ + "static/media/pic14.6513c002.jpg";